<template>
  <div class="hidden sm:block">
    <nav class="top-nav">
      <div class="container">
        <img
          class="sm:hidden h-16 w-16 object-cover"
          src="https://homesby360.s3.amazonaws.com/logo360.png"
        />
        <router-link class="sm:inline-block hidden navbar-brand" to="/"
          >360 Real Estate</router-link
        >

        <ul class="list-unstyled list-inline">
          <!-- class="hidden sm:inline-block sm:mr-8" -->
          <!-- <div> -->
          <div class="inline-block mr-4" id="hiddenMenu">
            <li class="list-inline-item m-r-1 ">
              <router-link class="nav-item nav-link" to="/reviews">
                <span
                  class="bg-blue-900 bg-opacity-25 text-blue-500 px-2 py-0 rounded-full text-sm -mr-1"
                >
                  {{ reviews.length }}
                </span>
                Reviews</router-link
              >
            </li>
            <li class="list-inline-item m-r-1">
              <router-link class="nav-item nav-link" to="/news"
                >News</router-link
              >
            </li>
            <li class="list-inline-item m-r-1">
              <router-link class="nav-item nav-link" to="/about"
                >About</router-link
              >
            </li>
            <li class="list-inline-item m-r-1">
              <router-link class="nav-item nav-link" to="/residents"
                >Residents</router-link
              >
            </li>
            <li class="list-inline-item m-r-1">
              <router-link class="nav-item nav-link" to="/clients"
                >360 Clients</router-link
              >
            </li>
            <li class="list-inline-item m-r-1">
              <router-link class="nav-item nav-link" to="/contact"
                >Contact</router-link
              >
            </li>
          </div>
          <!-- </div> -->

          <template v-if="userAuth" class="ml-4">
            <template v-if="user.email_verified_at">
              <div class="inline-block float-right pb-2">
                <div
                  v-if="roleUser === 'admin'"
                  class="inline-block"
                  x-data="{ openMenu: false }"
                >
                  <button
                    x-on:click="openMenu = true"
                    class="ml-2 relative p-1 focus:outline-none"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="-mb-1 w-5 h-5 text-white"
                    >
                      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                    </svg>
                    <span v-if="user.notifications.length >= 1" class="badge"
                      >{{ user.notifications.length }}
                    </span>
                  </button>

                  <div
                    x-show.transition="openMenu"
                    x-on:click.away="openMenu = false"
                    class="z-10 absolute right-20 top-10 p-3 mt-1 text-gray-600 bg-white bg-gray-100 rounded shadow-md messages"
                  >
                    <ul class="space-y-3">
                      <template v-if="user.notifications.length >= 1">
                        <li
                          v-for="notification in user.notifications"
                          :key="notification.id"
                          class="p-3 border rounded"
                        >
                          <div v-if="notification.data.requestShowing">
                            <span
                              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-pink-100 text-pink-800"
                            >
                              New Showing Request
                            </span>
                            <p>
                              {{ notification.data.requestShowing.address }}
                            </p>
                          </div>

                          <div v-else-if="notification.data.newSignature">
                            <span
                              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                            >
                              New Request Signature
                            </span>
                            <p>
                              {{ notification.data.newSignature.document_name }}
                            </p>
                          </div>

                          <div class="mt-1">
                            <button
                              @click="singleNotification(notification.id)"
                              class="px-2 text-xs bg-red-50 text-red-800 rounded-full"
                            >
                              Remove
                            </button>
                          </div>
                        </li>
                      </template>
                      <template v-else>
                        <li class="p-3 border rounded">
                          <p>Notifications Empty</p>
                        </li>
                      </template>
                    </ul>

                    <!-- <div class="flex justify-end mt-3">
                    <button
                      @click="clear"
                      class="rounded-lg px-2 text-sm text-gray-100 bgBlueColor rounded-sm"
                    >
                      clear all
                    </button>
                  </div> -->
                  </div>
                </div>

                <template class="dropdown text-center">
                  <button
                    class="text-gray-300 dropdown-toggle sm:mt-2"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Hi, {{ user.name }}
                  </button>
                  <div
                    class="dropdown-menu bg-dark"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <template v-if="roleUser === 'admin'">
                      <router-link
                        class="nav-item nav-link"
                        :to="{ name: 'ManageBlogs' }"
                        style="font-size: 14px;"
                        >Blogs</router-link
                      >

                      <router-link
                        class="nav-item nav-link"
                        to="/news"
                        style="font-size: 14px;"
                        >News</router-link
                      >

                      <router-link
                        class="nav-item nav-link"
                        to="/manage/clients"
                        style="font-size: 14px;"
                        >Clients</router-link
                      >

                      <router-link
                        class="nav-item nav-link"
                        to="/documents"
                        style="font-size: 14px;"
                        >Documents:
                      </router-link>

                      <router-link
                        class="nav-item nav-link"
                        to="/inventory"
                        style="font-size: 14px;"
                        >Inventory</router-link
                      >

                      <router-link
                        class="nav-item nav-link"
                        to="/manage/inventory"
                        style="font-size: 14px;"
                        >Manage Reviews</router-link
                      >

                      <router-link
                        class="nav-item nav-link"
                        to="/messages"
                        style="font-size: 14px;"
                        >Message Recieved</router-link
                      >

                      <router-link
                        class="nav-item nav-link"
                        to="/snapshots"
                        style="font-size: 14px;"
                        >Snapshots</router-link
                      >

                      <router-link
                        class="nav-item nav-link"
                        to="/crm"
                        style="font-size: 14px;"
                        >CRM</router-link
                      >

                      <router-link
                        class="nav-item nav-link"
                        :to="{ name: 'GeolocationIndex' }"
                        style="font-size: 14px;"
                        >Geolocation Index</router-link
                      >

                      <!-- <router-link
                      class="nav-item nav-link"
                      to="/idx"
                      style="font-size: 14px;"
                      >IDX</router-link
                    > -->
                    </template>

                    <template v-else-if="roleUser === 'RandCRM'">
                      <router-link
                        class="nav-item nav-link"
                        to="/manage/inventory"
                        style="font-size: 14px;"
                        >Manage Reviews</router-link
                      >

                      <router-link
                        class="nav-item nav-link"
                        to="/crm"
                        style="font-size: 14px;"
                        >CRM</router-link
                      >
                    </template>

                    <router-link
                      class="nav-item nav-link"
                      :to="{ name: 'Dashboard' }"
                      style="font-size: 14px;"
                      >Dashboard</router-link
                    >

                    <!-- <router-link
                    class="nav-item nav-link"
                    to="/profile"
                    style="font-size: 14px;"
                    >Profile</router-link
                  > -->

                    <a
                      class="nav-item nav-link"
                      @click="logout"
                      style="font-size: 14px;"
                      >Logout</a
                    >
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              <button
                type="button"
                @click="resendEmail"
                class="text-warning mr-2"
              >
                Resend email verification
              </button>
              <template class="dropdown">
                <button
                  class=" text-white dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Hi {{ user.name }}
                  <small class="text-warning">(Unverified)</small>
                </button>
                <div
                  class="dropdown-menu bg-dark"
                  aria-labelledby="dropdownMenuButton"
                >
                  <a
                    class="nav-item nav-link"
                    @click="logout"
                    style="font-size: 14px;"
                    >Logout</a
                  >
                </div>
              </template>
            </template>
          </template>

          <template class="ml-4" v-else>
            <li class="list-inline-item m-r-1">
              <router-link class="nav-item nav-link" to="/login"
                >Login</router-link
              >
            </li>
            <!--
            <li class="list-inline-item m-r-1">
              <router-link class="nav-item nav-link text-dark" to="/register"
                >Register</router-link
              >
            </li>
            -->
          </template>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      reviews: []
    };
  },

  created() {
    this.getReviews();
  },

  methods: {
    getReviews() {
      window.axios.get("/api/reviews").then(res => {
        this.reviews = res.data;
      });
    },

    singleNotification(noti) {
      window.axios.get("api/deleteNotification/" + noti).then(() => {
        this.$store.dispatch("getUser");
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Notification successfully removed",
          showConfirmButton: false,
          timer: 1500
        });
      });
    },

    clear() {
      window.axios.get("api/clear").then(() => {
        this.$store.dispatch("getUser");
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Notifications successfully clear",
          showConfirmButton: false,
          timer: 1500
        });
      });
    },

    resendEmail() {
      window.axios.post("email/resend").then(() => {
        Swal.fire({
          icon: "success",
          title: "Email successfully sent",
          text:
            "Hi Jane here, i sent you a new email. Please verify your email account",
          footer: "Check your email"
        });
      });
    },

    logout() {
      this.$store.dispatch("logout");
      this.$router.push({ name: "Login" });
    }
  },

  computed: {
    ...mapGetters({
      userAuth: "userAuth",
      user: "userLogin",
      roleUser: "userRole"
    })
  }
};
</script>

<style lang="scss">
$color-white: #fff;
$color-antiwhite: #edf2f4;
$color-coolgray: #8d99ae;
$color-gunmetal: #000000;
$color-imperialred: #8d99ae;
$color-candyred: #d90429;
$color-bordered: #2b2d42;

@media only screen and (max-width: 768px) {
  #hiddenMenu {
    display: none;
  }
}

@mixin bp-sm {
  @media only screen and (max-width: 768px) {
    @content;
    #hiddenMenu {
      display: none;
    }
  }
}

.badge {
  padding: 0;
  margin: 0;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #c20e0e;
  color: #ffffff;
  right: 0;
  border-radius: 9999px;
  font-size: 10px;
  min-width: 14px;
  line-height: 14px;
  min-height: 14px;
  text-align: center;
}

.top-hero-final {
  overflow: auto;
  background-color: #000;
  background-image: linear-gradient(rgba(#000000, 0.1), rgba(#000000, 0.1)),
    url("../assets/windows.jpg");

  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  // min-height: 800px;

  display: flex;
  align-items: center;
}

.top-hero {
  overflow: auto;
  background-color: #000;
  background-image: linear-gradient(
      rgba($color-gunmetal, 0.6),
      rgba($color-gunmetal, 0.6)
    ),
    url("../assets/Background6.jpeg");

  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  min-height: 800px;

  display: flex;
  align-items: center;
  justify-content: space-around;

  // h1 {
  //   color: $color-white;
  //   text-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
  //   font-weight: bold;
  //   text-transform: uppercase;
  //   width: 50%;
  //   letter-spacing: -1px;
  //   line-height: 0.9;
  // }
  p {
    color: $color-antiwhite;
  }
  @include bp-sm {
    min-height: 400px;
    padding-top: 50px;
  }
}

@media (max-width: 500px) {
  .top-hero {
    background-color: #000;
    background-image: linear-gradient(
        rgba($color-gunmetal, 0.4),
        rgba($color-gunmetal, 0.4)
      ),
      url("../assets/Background9.jpg");

    background-size: cover;
    background-position: center;
    background-attachment: fixed;
  }
}

@media (min-width: 320px) and (max-width: 500px) {
  .minimunHeight {
    height: 400px;
  }
}

.minimunHeight {
  height: 700px;
}

.mobileMinimunHeight {
  height: 380px;
}

.marginTop {
  margin-top: 55px;
}
.top-hero1 {
  background-color: #fafafa;
  background-image: linear-gradient(
      rgba(rgb(0, 0, 0), 0.75),
      rgba(rgb(0, 0, 0), 0.75)
    ),
    url("../assets/Background3.jpeg");
  background-size: cover;
  min-height: 100vh;
}

.top-hero4 {
  background-image: url("../assets/Logo.jpg");
  background-size: cover;
}

.top-hero6 {
  background-image: url("../assets/Bleu.jpeg");
  background-size: cover;
  background-position: right;
}

.top-hero7 {
  background-image: url("../assets/Banner.jpeg");
  background-size: cover;
  background-position: right;
}

.top-hero5 {
  background-color: #fafafa;
  background-image: linear-gradient(
      rgba(rgb(0, 0, 0), 0.9),
      rgba(rgb(0, 0, 0), 0.9)
    ),
    url("../assets/Background3.jpeg");
  background-size: 100%;
  min-height: 100vh;
  background-repeat: repeat-y;
}

.top-hero2 {
  background-color: #fafafa;
  background-image: linear-gradient(
      rgba(rgb(2, 2, 2), 0.75),
      rgba(rgb(0, 0, 0), 0.75)
    ),
    url("../assets/Background5.jpeg");
  background-size: cover;
  background-position: bottom;
  background-attachment: fixed;
  min-height: 100vh;
}

.rentals {
  background-image: linear-gradient(
      rgba(rgb(0, 0, 0), 0.5),
      rgba(rgb(0, 0, 0), 0.5)
    ),
    url("../assets/Background5.jpeg");
  background-size: cover;
  background-position: center;
}

.listing {
  background-image: linear-gradient(
      rgba(rgb(0, 0, 0), 0.5),
      rgba(rgb(0, 0, 0), 0.5)
    ),
    url("../assets/Background1.jpeg");
  background-size: cover;
  background-position: center;
}

.bgCardManage {
  background-image: linear-gradient(
      rgba(rgb(177, 224, 255), 0.3),
      rgba(rgb(169, 221, 255), 0.3)
    ),
    url("../assets/front_porch.jpg");

  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

.bgCardBuyer {
  background-image: linear-gradient(
      rgba(rgb(177, 224, 255), 0.3),
      rgba(rgb(169, 221, 255), 0.3)
    ),
    url("../assets/Background9.jpeg");

  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

.bgCardListing {
  background-image: linear-gradient(
      rgba(rgb(177, 224, 255), 0.3),
      rgba(rgb(169, 221, 255), 0.3)
    ),
    url("../assets/Background3.jpeg");

  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

.sales {
  background-image: linear-gradient(
      rgba(rgb(0, 0, 0), 0.5),
      rgba(rgb(0, 0, 0), 0.5)
    ),
    url("../assets/Backg4.jpeg");
  background-size: cover;
  background-position: center;
}

// .top-hero4 {
//   background-color: #fafafa;
//   background-image: url("https://api.homesby360.com/images/360.jpg");
//   background-size: cover;
// }

.top-nav {
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  &.sticky {
    position: fixed;
  }
  ul {
    float: right;
  }
  a {
    font-size: 1.1rem;
    color: $color-antiwhite;
    text-decoration: none;
    border-bottom: 3px solid transparent;
    padding: 0 0 5px;
    transition: 0.25s;
    margin: 5px;
  }
  a:hover {
    color: $color-imperialred;
    border-color: $color-imperialred;
  }
  .router-link-exact-active {
    color: $color-imperialred;
    border-color: $color-bordered;
  }
}
</style>
